import fetch from '@adc/fetch'
import configment from '@adc/configment'
import { utils } from '@adc/ui-morpheus'
import seek from '@adc/seek'

const seekThroughGraph = async (req, fetchOptions, type) => {
  const { offset, size, sortBy, filterBy, fields } = fetchOptions
  const query = utils.elasticSearch.buildQuery(filterBy)

  const q = seek.for(type).size(size).offset(offset).fields(fields)

  // Hacking out the seek client to get this working, and to take advantage of filter logic we already have in toolkit
  q._sort = sortBy
  q._query = {
    toObject: () => query,
  }

  const res = await fetch(`${configment.get('RESI_GRAPH_API_URL')}/graphql`, {
    method: 'POST',
    useProxy: false,
    body: {
      query: q.toQuery(false),
    },
    headers: {
      'Auction-Graph-Experiments': 'directMsSearchAccess',
    },
  })

  return res.body.data.seek
}

const seekThroughProxy = async (req, fetchOptions, type) => {
  const { offset, size, sortBy, filterBy } = fetchOptions
  const query = utils.elasticSearch.buildQuery(filterBy)

  const res = await fetch(
    `${configment.get('RESI_CS_SEEK')}/resi/seek/v1/${type}/search`,
    {
      req,
      method: 'POST',
      //
      // Unlike other places, we do not specify fields for seek here. That is because we end up needing a lot
      // of different fields from the index, and it slows down seek considerably. See above where we do the same
      // thing when going through graph, via calling `toQuery(false)`.
      //
      body: {
        query,
        sort: sortBy,
        offset,
        size,
      },
    }
  )

  return res.body
}

export { seekThroughGraph, seekThroughProxy }
